module.exports = __webpack_public_path__ + "static/img/monolake.d9e3239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/monolake.jpg
// module id = n0aw
// module chunks = 1